import axiosLib from 'axios'
import router from '../router'
import { message } from 'ant-design-vue'

const baseURL = process.env['VUE_APP_BASE_URL'] || 'http://localhost:3000'
const axios = axiosLib.create({
  baseURL
  // baseURL: 'https://cellar-api.dzmtoast.top'
})

axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  config.headers['Authorization'] = `Bearer ${token}`
  return config
})

axios.interceptors.response.use(
  resp => {
    return resp.data
  },
  err => {
    if (err.response.status === 401 && router.history.current.path !== '/login') {
      router.push('/login')
    }
    message.error(err.response.data.message)
    throw err
  }
)

export default axios